import { render, staticRenderFns } from "./DetailsTitleBrief.vue?vue&type=template&id=4f8ea8b1&scoped=true&"
import script from "./DetailsTitleBrief.vue?vue&type=script&lang=js&"
export * from "./DetailsTitleBrief.vue?vue&type=script&lang=js&"
import style0 from "./DetailsTitleBrief.vue?vue&type=style&index=0&id=4f8ea8b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8ea8b1",
  null
  
)

export default component.exports